import Tabby from 'tabbyjs';

document.addEventListener('DOMContentLoaded', () => {
  const tabsEl = document.querySelector('[data-tabs]');

  if (tabsEl) {
    const tabs = new Tabby('[data-tabs]');

    tabs.setup();
  }
});



// WEBPACK FOOTER //
// ./src/scripts/modules/tabs.js